import { render, staticRenderFns } from "./RecycleModal.vue?vue&type=template&id=49ec4d70&scoped=true"
import script from "./RecycleModal.vue?vue&type=script&lang=js"
export * from "./RecycleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ec4d70",
  null
  
)

export default component.exports